import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {} from '../actions/news';
import {
  LIVE_EVENTS_GET,
  SESSION_RESULT_GET,
  SESSION_USERS_GET,
} from '../actions/liveEvent';

const initialState = {
  list: {
    todayEvents: [],
    nextEvents: [],
  },
  details: {},
  sessionUsers: {},
  sessionResult: {
    list: [],
    filters: {},
    pager: {},
  },
};

const liveEventReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case LIVE_EVENTS_GET._SUCCESS: {
        const { isToday, response } = action;
        if (isToday) draft.list.todayEvents = response?.items || [];
        else draft.list.nextEvents = response?.items || [];
        break;
      }

      case SESSION_USERS_GET._SUCCESS: {
        const { activity_id, response } = action;
        draft.sessionUsers[activity_id] = response;
        break;
      }
      case SESSION_USERS_GET._ERROR: {
        const { activity_id } = action;
        draft.sessionUsers[activity_id] = [];
        break;
      }

      case SESSION_RESULT_GET._SUCCESS: {
        const { response } = action;
        draft.sessionResult.list = response?.items || [];
        draft.sessionResult.filters = response?.filters || {};
        draft.sessionResult.pager = response?.pager || {};
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default liveEventReducer;
